import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronRightIcon, PlusIcon } from 'lucide-react';
interface ConsumptionSectionProps {
  id: string;
  title: string;
  /** Kort status i headeren, fx "4,5 af 6,0 t". */
  summary: string;
  addLabel: string;
  open: boolean;
  onToggle: () => void;
  onAdd: () => void;
  children: React.ReactNode;
}

/** Foldbar sektion. Tilføj-knappen virker også, når sektionen er lukket. */
export function ConsumptionSection({
  id,
  title,
  summary,
  addLabel,
  open,
  onToggle,
  onAdd,
  children
}: ConsumptionSectionProps) {
  const panelId = `${id}-indhold`;
  return <div className="border-t border-line first:border-t-0" data-id="element-132" data-mp="21hnwyiz8oy3o">
      <div className="flex items-center gap-2" data-id="element-133" data-mp="26fpg13wo0xf5">
        <button type="button" onClick={onToggle} aria-expanded={open} aria-controls={panelId} className="flex min-h-[3.25rem] min-w-0 flex-1 items-center gap-2.5 py-2 text-left" data-id="element-134" data-mp="26gicnc1wu6jk">
          <ChevronRightIcon className={`h-4 w-4 shrink-0 text-ink-muted transition-transform duration-200 ease-smooth ${open ? 'rotate-90' : ''}`} aria-hidden="true" data-id="element-135" data-mp="4lzxgdvz31bu" />
          <span className="whitespace-nowrap font-display text-[15px] font-bold text-ink" data-id="element-136" data-mp="fola9sod9dcu">{title}</span>
          <span className="truncate text-sm text-ink-muted" data-id="element-137" data-mp="pg7jjjh592cy">{summary}</span>
        </button>
        <button type="button" onClick={onAdd} className="inline-flex h-10 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-3 text-sm font-medium text-accent transition-colors duration-150 hover:bg-accent/10 hover:text-accent-deep" data-id="element-138" data-mp="pild1nw6e6ie">
          <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-139" data-mp="ap8dog7p0rx2" />
          <span className="hidden sm:inline" data-id="element-140" data-mp="5r6vdxi3cwmn">{addLabel}</span>
          <span className="sm:hidden" data-id="element-141" data-mp="1m6hvkyb6bbw9">Tilføj</span>
        </button>
      </div>
      <AnimatePresence initial={false} data-id="element-142" data-mp="1m8kuk7ub0fd4">
        {open && <motion.div id={panelId} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-143" data-mp="1h6dh1dttsr8o">
            <div className="pb-4 pl-6" data-id="element-144" data-mp="nv6vz45jii77">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}